import { ExecutionEnvironment } from '@/utils/ExecutionEnvironment'
import type { RootState } from './interfaces'
import { preloadedState } from './preloadedState'

export const getStore = async () => {
  let store
  if (!ExecutionEnvironment.isSsr) store = await import('./clientStore')

  return store
}

export const getInitialState = <TName extends keyof RootState>(reducerName: TName, initialState: RootState[TName]): RootState[TName] => {
  if (ExecutionEnvironment.isSsr) return initialState

  return preloadedState[reducerName] ?? initialState
}
